import { Grid } from "@mui/material";
import { CompanyAddress } from "./CompanyAddress";
import { TitledGrid } from "../common/TitledGrid";
import React from "react";
import * as api from "../../api/generated-api";
import { OrganizationName } from "../organization/OrganizationName";

export const CompanyInformationGrid = (props: {
  company: api.Organization;
}) => {
  const { company } = props;

  return (
    <TitledGrid>
      <Grid item xs={6}>
        <OrganizationName organization={company} />
      </Grid>
      <Grid item xs={6}>
        <CompanyAddress company={company} />
      </Grid>
    </TitledGrid>
  );
};
